<template>
    <div class="cosmetic-dentistry-container" id="cosmetic-dentistry">
        <section class="container">
            <div class="row-custom reverse">
                <div class="team-col">
                    <img src="../assets/images/facings-techniques.jpg" id="facings-techniques-img">
                </div>
                <div class="team-col">
                    <h1>Restauratieve Tandheelkunde</h1>
                    <p>
                        Een gezonde mond begint met sterke en goed functionerende tanden. Als tanden beschadigd zijn door bijvoorbeeld gaatjes, slijtage of een ongeluk, zorgen wij voor professioneel herstel. Dit doen we met duurzame materialen zoals composietvullingen, kronen en bruggen. Wij streven ernaar om zowel de functie als het uiterlijk van uw gebit te herstellen. Of het nu gaat om een kleine vulling of een volledige brug, wij nemen de tijd om het resultaat naadloos te laten aansluiten bij uw natuurlijke tanden.
                    </p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "CosmeticDentistry",
    mounted() {
        const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('show')
          } 
        })
      })

      const hiddenElements = document.querySelectorAll('.hidden')
      hiddenElements.forEach((el) => observer.observe(el))
    }
}
</script>

<style scoped>
.hidden {
  opacity: 0;
  transform: translateY(100px);
  transition: all 1.5s;
}

.show {
  opacity: 1;
  transform: translateY(0);
}

.cosmetic-dentistry-container {
    padding: 4rem 0;
}

.team-col {
    flex-basis: 48%;
}

.row-custom {
    margin-bottom: 0px;
}
.team-col img {
    width: 100%;
    max-width: 600px;
}
.team-col h1 {
    padding-top: 0;
}
.team-col p {
    padding: 15px 0 0;
    font-size: 1.4rem;
}

#facings-techniques-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}



@media(max-width: 991px) {
    .row-custom {
        margin-bottom: 20px;
    }
    .row-custom {
        flex-direction: column;
    }
    h1 {
        font-size: 20px;
        text-align: center;
    }

    .team-col img {
        max-width: 100%;
    }

    .team-col p {
        padding: 7px 0px 0px;
    }

    #facings-techniques-img {
        height: 200px;
    }
    .reverse {
        flex-direction: column-reverse;
    }

}

</style>